/* eslint-disable no-sequences */

/**
 * Core routes that are shared with portable P2P.
 */

// libs
import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import Page from './containers/page'
import validateRoutes from './utils/validate-routes'
import homepageExternalRedirect from './utils/homepage-external-redirect'

import {
  Preview,
  SendSuccess,
  FundingOptionSelector,
  BuySuccess,
  PayRequestSuccessRedux,
} from './lazy-components'

// Have to specify the last pathname component or these routes will
// accidentally match/render for `/:type/external`.

export default ROOT_URL => {
  const tags = {
    send: `${ROOT_URL}/send/:_(preview|select|success)?`,
    buy: `${ROOT_URL}/buy/:_(preview|select|success)?`,
    payRequest: `${ROOT_URL}/payRequest/:requestId/:requestLegId/:_(select|success|external)?`,
    external: `${ROOT_URL}/:type/external/:env?`,
  }
  return [
    <Route exact key={tags.send} path={tags.send}>
      <Page>
        <Switch>
          <Route
            exact
            path={`${ROOT_URL}/send`}
            render={props => (
              <Redirect
                to={{
                  pathname: '/myaccount/transfer/homepage/pay',
                  params: { flowType: 'send' },
                }}
              />
            )}
          />
          <Route
            path={`${ROOT_URL}/send/preview`}
            render={props => {
              return validateRoutes(props) || <Preview {...props} />
            }}
          />
          <Route
            path={`${ROOT_URL}/send/select`}
            render={props =>
              validateRoutes(props) || <FundingOptionSelector {...props} />
            }
          />
          <Route
            path={`${ROOT_URL}/send/success`}
            render={props =>
              validateRoutes(props) || <SendSuccess {...props} />
            }
          />
        </Switch>
      </Page>
    </Route>,
    <Route exact key={tags.buy} path={tags.buy}>
      <Page>
        <Switch>
          <Route
            exact
            path={`${ROOT_URL}/buy`}
            render={props => (
              <Redirect
                to={{
                  pathname: '/myaccount/transfer/homepage/pay',
                  params: { flowType: 'buy' },
                }}
              />
            )}
          />
          <Route
            path={`${ROOT_URL}/buy/preview`}
            render={props => {
              return validateRoutes(props) || <Preview {...props} />
            }}
          />
          <Route
            path={`${ROOT_URL}/buy/select`}
            render={props =>
              validateRoutes(props) || <FundingOptionSelector {...props} />
            }
          />
          <Route
            path={`${ROOT_URL}/buy/success`}
            render={props => validateRoutes(props) || <BuySuccess {...props} />}
          />
        </Switch>
      </Page>
    </Route>,
    <Route exact key={tags.payRequest} path={tags.payRequest}>
      <Page>
        <Switch>
          <Route
            exact
            path={`${ROOT_URL}/payRequest/:requestId/:requestLegId`}
            render={props => {
              return <Preview {...props} />
            }}
          />
          <Route
            path={`${ROOT_URL}/payRequest/:requestId/:requestLegId/select`}
            component={FundingOptionSelector}
          />
          <Route
            path={`${ROOT_URL}/payRequest/:requestId/:requestLegId/success`}
            component={PayRequestSuccessRedux}
          />
          <Route
            path={`${ROOT_URL}/payRequest/:requestId/:requestLegId/external`}
            component={props => homepageExternalRedirect(props)}
          />
        </Switch>
      </Page>
    </Route>,
    <Route
      exact
      key={tags.external}
      path={tags.external}
      render={props => homepageExternalRedirect(props)}
    />,
  ]
}
